/*
 * Embroidery add-on. When a design is selected, intercepts the boot's
 * add-to-cart and adds boot + embroidery variant in one /cart/add.js call,
 * linked via line-item properties. Otherwise the native flow is untouched.
 */
window.Blundstone = window.Blundstone || {};

if (!customElements.get('embroidery-selector')) {
  customElements.define(
    'embroidery-selector',
    class EmbroiderySelector extends HTMLElement {
      constructor() {
        super();
        this.onEnableChange = this.onEnableChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
      }

      connectedCallback() {
        this.form = document.getElementById(this.dataset.productFormId);
        this.enableInput = this.querySelector('.js-embroidery-enable');
        this.designsFieldset = this.querySelector('.js-embroidery-designs');
        this.errorEl = this.querySelector('.js-embroidery-error');
        if (!this.form || !this.enableInput || !this.designsFieldset) return;

        this.enableInput.addEventListener('change', this.onEnableChange);
        // Capture phase on document → runs before the form's own submit listener.
        document.addEventListener('submit', this.onFormSubmit, true);
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.onFormSubmit, true);
        if (this.enableInput) this.enableInput.removeEventListener('change', this.onEnableChange);
      }

      onEnableChange() {
        const enabled = this.enableInput.checked;
        this.designsFieldset.disabled = !enabled;
        this.designsFieldset.hidden = !enabled;
        if (!enabled) this.clearError();
      }

      get selectedDesign() {
        if (!this.enableInput.checked) return null;
        return this.querySelector('.js-embroidery-design:checked');
      }

      onFormSubmit(evt) {
        if (evt.target !== this.form) return;
        const design = this.selectedDesign;
        if (!design) return; // No embroidery → let the native add-to-cart run.

        evt.preventDefault();
        evt.stopImmediatePropagation();
        // Guard against double-submit (button uses aria-disabled, not disabled).
        if (this.loading) return;
        this.addToCart(design);
      }

      addToCart(design) {
        this.clearError();

        const bootIdInput = this.form.querySelector('[name="id"]');
        if (!bootIdInput) return;

        const quantityInput = this.form.querySelector('[name="quantity"]');
        const quantity = parseInt(quantityInput && quantityInput.value, 10) || 1;

        const properties = {
          _embroidery_for: this.dataset.bootHandle || this.dataset.bootTitle,
          Design: design.dataset.designName,
          _final_sale: 'true',
        };
        if (this.dataset.position) properties.Position = this.dataset.position;

        const items = [
          { id: bootIdInput.value, quantity },
          { id: design.value, quantity, properties },
        ];

        const cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = { items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement(document.activeElement);
        }

        this.setLoading(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify(body);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              return;
            }
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'embroidery-selector',
                productVariantId: items[0].id,
                cartData: response,
              });
            }
            cart.renderContents(response);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          })
          .catch((e) => {
            console.error(e);
            this.showError();
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(isLoading) {
        this.loading = isLoading;
        const submitButton = this.form.querySelector('[type="submit"]');
        if (!submitButton) return;
        submitButton.classList.toggle('loading', isLoading);
        if (isLoading) {
          submitButton.setAttribute('aria-disabled', 'true');
        } else {
          submitButton.removeAttribute('aria-disabled');
        }
        const spinner = submitButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !isLoading);
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent =
          message || this.dataset.errorText || 'Sorry, that embroidery could not be added.';
        this.errorEl.hidden = false;
      }

      clearError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }
  );
}
